
/**
 * Utilities for extracting features from dog school data
 */

// Helper function to extract features from about JSON
export const extractFeatures = (aboutJson: string | null): any => {
  const defaultFeatures = {
    hasFreeParking: false,
    isWheelchairAccessible: false,
    hasPrivateLessons: true,
    hasGroupLessons: true,
    hasDogLicense: false,
    isLGBTQFriendly: false,
    hasMultiLanguageSupport: false,
  };
  
  if (!aboutJson) return defaultFeatures;
  
  try {
    const about = typeof aboutJson === 'string' ? JSON.parse(aboutJson.replace(/'/g, '"')) : aboutJson;
    
    // If about is null or not an object, return default features
    if (!about || typeof about !== 'object') return defaultFeatures;
    
    // Extract features based on the structure
    return {
      hasFreeParking: 
        (about.Parkplätze && 
         (about.Parkplätze['Kostenlose Parkplätze'] || 
          about.Parkplätze['Kostenlose Parkplätze an der Straße'])) || 
        (about.Other && about.Other.parking) || 
        false,
      
      isWheelchairAccessible: 
        (about.Barrierefreiheit && 
         (about.Barrierefreiheit['Rollstuhlgerechter Eingang'] || 
          about.Barrierefreiheit['Rollstuhlgerechte Sitzgelegenheiten'] || 
          about.Barrierefreiheit['Rollstuhlgerechter Parkplatz'])) || 
        (about.Other && about.Other.wheelchair_accessible) || 
        false,
      
      hasPrivateLessons: true, // Assuming most schools offer this by default
      
      hasGroupLessons: true, // Assuming most schools offer this by default
      
      hasDogLicense: false, // No clear indicator in data, defaulting to false
      
      isLGBTQFriendly: 
        (about.Atmosphäre && about.Atmosphäre['LGBTQ+ freundlich']) || 
        (typeof aboutJson === 'string' && aboutJson.toLowerCase().includes('lgbtq+')) ||
        (about.Other && about.Other.lgbtq_friendly) || 
        false,
        
      hasMultiLanguageSupport:
        (typeof aboutJson === 'string' && 
         (aboutJson.toLowerCase().includes('mehreren sprachen') || 
          aboutJson.toLowerCase().includes('mehrere sprachen') || 
          aboutJson.toLowerCase().includes('multilingual') || 
          aboutJson.toLowerCase().includes('multi-lingual'))) ||
        (about.Other && about.Other.multilingual) ||
        false,
    };
  } catch (e) {
    console.error("Error parsing about JSON:", e);
    return defaultFeatures;
  }
};
